module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeTxt),
      expression: "beforeTxt"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "数字..."
    },
    domProps: {
      "value": (_vm.beforeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beforeTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertDxRmb()
      }
    }
  }, [_c('span', [_vm._v("大写\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertXxRmb()
      }
    }
  }, [_c('span', [_vm._v("小写\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afterTxt),
      expression: "afterTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "中文..."
    },
    domProps: {
      "value": (_vm.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.afterTxt = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-792536cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/rmbconvert.vue
// module id = 601
// module chunks = 2